// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KlmY3","colMin":"styles_colMin__RWBHh"};